import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-canvas px-4 py-14 sm:px-6 sm:py-20" data-id="element-34" data-mp="1bmvbwt4ic0p4">
      <div className="mx-auto max-w-2xl" data-id="element-35" data-mp="1gk58qtu87emz">
        <h2 className="text-center font-display text-2xl font-extrabold leading-tight text-brand-deep sm:text-4xl" data-id="element-36" data-mp="249g3nuowaet7">
          Preguntas frecuentes
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-center text-base leading-relaxed text-gray-600" data-id="element-37" data-mp="28a00ex5k3get">
          Todo lo que necesitas saber antes de empezar tu reinicio.
        </p>

        <div className="mt-8 divide-y divide-gray-200 overflow-hidden rounded-2xl border border-gray-200 bg-white" data-id="element-38" data-mp="1zh6ieryq62x9">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.pregunta} data-id="element-39" data-mp="2s03dwmma9gix" data-mpi={i}>
                <h3 data-id="element-40" data-mp="14v0tmwdubu78">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-base font-extrabold text-brand-deep transition-colors duration-150 ease-out hover:bg-brand-soft focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand sm:text-lg" data-id="element-41" data-mp="14uir5i0l4jqv">
                    <span data-id="element-42" data-mp="1xjpmy98nmv8f">{faq.pregunta}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-43" data-mp="1xio7ztoipolf" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-44" data-mp="3uem25znrygpa">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-45" data-mp="1yaxsf273ra0p">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-gray-600 sm:text-base" data-id="element-46" data-mp="2h5uyyklj13br">
                        {faq.respuesta}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}